export const flowCertificateZH = {
  flowCertificate1: '打包下载',
  flowCertificate2: '一键领取',
  flowCertificate3: '下载',
  flowCertificate4: '暂无数据',
  flowCertificate5: '学术荣誉领取邮箱',
  flowCertificate6: '请输入你的学术荣誉领取邮箱',
  flowCertificate7: '任务状态不符， 请返回任务卡重新进入~~~',
  flowCertificate8: '请输入邮箱地址',
  flowCertificate9: '申请已发送，请稍后查看邮箱',
  flowCertificate10: '申请发送失败，请检查邮箱是否正确',
  flowCertificate11: '网络出了点小问题，请稍后再试！',
  flowCertificate12: '提示',
  flowCertificate13: '邮箱格式有误，请重新输入！',
  flowCertificate14: '请输入邮箱！',
  flowCertificate15: '说明：如需修改邮箱，请前往报名资料进行修改，修改完成后再点击提交，系统会给您重新发送证书。',
  flowCertificate16: '证书',
  flowCertificate17: '请用电脑访问www.webloom.cn，查看'
}

export const flowCertificateEN = {
  flowCertificate1: 'Package Download',
  flowCertificate2: 'One-click claim',
  flowCertificate3: 'Download',
  flowCertificate4: 'No data',
  flowCertificate5: 'E-mail for Academic Honors',
  flowCertificate6: 'Please enter your Academic Honours Recipient Email Address',
  flowCertificate7: 'The task status does not match, please return to the task card to re-enter~~~',
  flowCertificate8: 'Please enter your email address',
  flowCertificate9: 'The application has been sent, please check the email later',
  flowCertificate10: 'If the application fails to be sent, please check if the email address is correct',
  flowCertificate11: 'Network error, please try again later!',
  flowCertificate12: 'Prompt',
  flowCertificate13: 'The email format is incorrect, please re-enter!',
  flowCertificate14: 'Please enter your email!',
  flowCertificate15: 'Note: if you need to modify the mailbox, please go to the registration material to modify, and then click submit after the modification. The system will send you the certificate again. ',
  flowCertificate16: 'Certificate',
  flowCertificate17: 'Please visit www.webloom.cn from your computer to see'
}



// WEBPACK FOOTER //
// ./src/assets/locale/flow/certificate.js